"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultErrorMap = void 0;
var util_1 = require("./helpers/util");
var ZodError_1 = require("./ZodError");
var defaultErrorMap = function (error, _ctx) {
    var message;
    switch (error.code) {
        case ZodError_1.ZodIssueCode.invalid_type:
            if (error.received === "undefined") {
                message = "Required";
            }
            else {
                message = "Expected " + error.expected + ", received " + error.received;
            }
            break;
        case ZodError_1.ZodIssueCode.nonempty_array_is_empty:
            message = "List must contain at least one item";
            break;
        case ZodError_1.ZodIssueCode.unrecognized_keys:
            message = "Unrecognized key(s) in object: " + error.keys
                .map(function (k) { return "'" + k + "'"; })
                .join(", ");
            break;
        case ZodError_1.ZodIssueCode.invalid_union:
            message = "Invalid input";
            break;
        case ZodError_1.ZodIssueCode.invalid_literal_value:
            message = "Input must be \"" + error.expected + "\"";
            break;
        case ZodError_1.ZodIssueCode.invalid_enum_value:
            message = "Input must be one of these values: " + error.options.join(", ");
            break;
        case ZodError_1.ZodIssueCode.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case ZodError_1.ZodIssueCode.invalid_return_type:
            message = "Invalid function return type";
            break;
        case ZodError_1.ZodIssueCode.invalid_date:
            message = "Invalid date";
            break;
        case ZodError_1.ZodIssueCode.invalid_string:
            if (error.validation !== "regex")
                message = "Invalid " + error.validation;
            else
                message = "Invalid";
            break;
        case ZodError_1.ZodIssueCode.too_small:
            if (error.type === "array")
                message = "Should have " + (error.inclusive ? "at least" : "more than") + " " + error.minimum + " items";
            else if (error.type === "string")
                message = "Should be " + (error.inclusive ? "at least" : "over") + " " + error.minimum + " characters";
            else if (error.type === "number")
                message = "Value should be greater than " + (error.inclusive ? "or equal to " : "") + error.minimum;
            else
                message = "Invalid input";
            break;
        case ZodError_1.ZodIssueCode.too_big:
            if (error.type === "array")
                message = "Should have " + (error.inclusive ? "at most" : "less than") + " " + error.maximum + " items";
            else if (error.type === "string")
                message = "Should be " + (error.inclusive ? "at most" : "under") + " " + error.maximum + " characters long";
            else if (error.type === "number")
                message = "Value should be less than " + (error.inclusive ? "or equal to " : "") + error.maximum;
            else
                message = "Invalid input";
            break;
        case ZodError_1.ZodIssueCode.custom:
            message = "Invalid input.";
            break;
        case ZodError_1.ZodIssueCode.invalid_intersection_types:
            message = "Intersections only support objects";
            break;
        default:
            message = "Invalid input.";
            util_1.util.assertNever(error);
    }
    return { message: message };
};
exports.defaultErrorMap = defaultErrorMap;
//# sourceMappingURL=defaultErrorMap.js.map